var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BaseInput } from './base-input';
import { Button } from './button';
export var QuantityInput = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, _b = _a.min, min = _b === void 0 ? 1 : _b, _c = _a.max, max = _c === void 0 ? 99 : _c, props = __rest(_a, ["label", "value", "onChange", "min", "max"]);
    var handleDecrement = function () {
        if (value > min) {
            onChange(value - 1);
        }
    };
    var handleIncrement = function () {
        if (value < max) {
            onChange(value + 1);
        }
    };
    var handleInputChange = function (e) {
        var inputValue = parseInt(e.target.value, 10);
        if (!isNaN(inputValue)) {
            if (inputValue >= min && inputValue <= max) {
                onChange(inputValue);
            }
            else if (inputValue < min) {
                onChange(min);
            }
            else if (inputValue > max) {
                onChange(max);
            }
        }
    };
    return (_jsxs("div", { className: 'group flex items-center focus:ring border border-collapse rounded-md h-full w-full', children: [label && _jsx("label", { className: 'mr-2 text-sm font-medium text-gray-700', children: label }), _jsx(Button, { variant: 'secondary', onClick: handleDecrement, disabled: value <= min, className: 'rounded-none rounded-l-md h-full', children: "-" }), _jsx(BaseInput, __assign({ type: 'text', value: value, onChange: handleInputChange, className: '!text-center !w-full !h-full', inputMode: 'numeric', pattern: '[0-9]*' }, props)), _jsx(Button, { variant: 'secondary', onClick: handleIncrement, disabled: value >= max, className: 'rounded-none rounded-r-md h-full', children: "+" })] }));
};
